/**
 * Returns the HTML exponential representation of a number
 * @param {number} number Number
 * @param {number} [digits=2] Number of decimals to represent
 * @returns {[number, number]} Base part and exponent part as an Array of two numbers
 */
export function toExponential (number, digits = 2) {
  return parseFloat(number)
    .toExponential(digits)
    .split('e')
}

/**
 * Returns the HTML exponential representation of a number
 * @param {number} number Number
 * @param {number} [digits=2] Number of decimals to represent
 * @returns {string} HTML string
 */
export function toExponentialHTML (number, digits = 2) {
  const [base, exponent] = toExponential(number, digits)
  return `${base}×10<sup>${exponent}</sup>`
}

/**
 * Returns the exponent of the number using the base specified
 * @param {number} number
 * @param {number} [base=10]
 * @returns {number}
 */
export function exponent (number, base = 10) {
  if (number === 0) {
    return 0
  }
  return Math.log(Math.abs(number)) / Math.log(base)
}

/**
 * Returns the numeric unit of the number using a list of units
 * @param {number} number Number
 * @param {number} units List of units used to represent the number
 * @param {number} [base=10] Base
 * @returns {string}
 */
export function unit (number, units, base = 10) {
  return units[Math.floor(exponent(number, base)) + Math.floor(units.length * 0.5)]
}

/**
 * Returns the string representation of the N content in [kg N / ha].
 * @param {number} nContent Nitrogen content in [kg N / m^2]
 * @returns {string}
 */
export function formatNContent (nContent) {
  return (nContent * 10000).toFixed(2)
}

export default {
  toExponential,
  toExponentialHTML,
  exponent,
  unit,
  formatNContent
}
